import stressedAtDesk from "@/assets/images/collect/stressed-person-using-computer-at-desk.png";
import { Button } from "@/components/Button";
import Modal from "@/components/Modal/Modal";
import { H1 } from "@/components/Typography";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { tv } from "tailwind-variants";

interface IProps {
  isOpen: boolean;
  closeModal: () => void;
}

const styles = tv({
  slots: {
    base: "flex flex-col items-center justify-center gap-10 text-center",
    ctaWrapper: "flex flex-row justify-center",
    image: "w-full max-w-[380px]",
  },
});

const DelinquentModal = ({ isOpen, closeModal }: IProps) => {
  const { t } = useTranslation();
  const { base, image, ctaWrapper } = styles();
  const navigate = useNavigate();

  const onClickApproveCharge = () => {
    navigate("/settings/billing");
    closeModal();
  };

  const renderImage = () => <img className={image()} src={stressedAtDesk} />;

  const renderContent = () => (
    <>
      <H1 className="font-bold">
        {t("components.modal.delinquentModal.heading")}
      </H1>
      <p>{t("components.modal.delinquentModal.paragraph1")}</p>
      <p>{t("components.modal.delinquentModal.paragraph2")}</p>
    </>
  );

  const renderCta = () => (
    <div className={ctaWrapper()}>
      <Button as="button" variant="primary" onClick={onClickApproveCharge}>
        {t("components.modal.delinquentModal.cta")}
      </Button>
    </div>
  );

  return (
    <Modal isOpen={isOpen} toggleIsOpen={closeModal} width="lg">
      <div className={base()}>
        {renderImage()}
        {renderContent()}
        {renderCta()}
      </div>
    </Modal>
  );
};

export default DelinquentModal;
